/**
 * Exported default variables.
 */

/**
 * EVENTS
 */
const EVENT_CATEGORIES = [
	['All Types', 'كل الأنواع'],
	['fires', 'الحرائق'],
	['storm', 'العواصف'],
	['ice', 'الثلج'],
	['water', 'الماء'],
	['land', 'الأرض'],
	['ocean', 'المحيطات']
];
const POI_CATEGORIES = [
	['All Types', 'كل الأنواع'],
	['religious', 'دينية'],
	['tourism', 'سياحية'],
	['geographical', 'جغرافية'],
	['agricultural', 'زراعية'],
	['3dimages', 'صور ثلاثية الأبعاد']
];
const GMAP_CATEGORIES = [
	['All Types', 'كل الأنواع'],
	['geographical', 'جغرافية']
];
const EVENTS_YEAR_INDEX = null; // to trigger initial state update
const EVENTS_CATEGORY_INDEX = 0;
const EVENTS_SHOW_ON_GLOBE = false;
const EVENTS_SHOW_LATEST = true;
const EVENTS_LATEST_LIMIT = 3;
const LIGHT_STATUS = true;
const CITY_NAME_STATUS = false;
const GROUND_TRACK_STATUS = false;

const POI_YEAR_INDEX = 0;
const POI_CATEGORY_INDEX = 0;
const POI_SHOW_LATEST = true;
const POI_LATEST_LIMIT = 3;

const GMAP_YEAR_INDEX = 0;
const GMAP_CATEGORY_INDEX = 0;
const GMAP_SHOW_LATEST = true;
const GMAP_LATEST_LIMIT = 3;

/**
 * MISSIONS
 */
const MISSION_CATEGORIES = [['All Types', 'كل الأنواع'], ['Atmosphere', 'البعثات الفضائية'], ['Sea', 'البحر'], ['Land', 'الأرض']];
const MISSION_TIME_GROUPS = [['Current', 'الحالية'], ['Future', 'المستقبلية']];
const MISSION_TIME_GROUP_CATEGORIES = {
	Current: 'operating',
	Future: 'planned'
};
const MISSION_TIMES = {
	CURRENT: 'الوقت في المدار: ',
	FUTURE: 'الإطلاق المتوقع: '
};
const MISSIONS_TIME_GROUP_INDEX = 0;
const MISSIONS_CATEGORY_INDEX = 0;

/**
 * VITALS
 */
// const VITAL_CATEGORIES = ['المؤشرات الرئیسیة'];
const VITAL_CATEGORIES = [['Key indicators', 'المؤشرات الرئیسیة'], ['Data Animations & Graphics', 'الرسوم المتحركة للبيانات والرسوم البيانية']];
const VITALS_CATEGORY_INDEX = 0;

/**
 * VISIBLE EARTH
 */

// Max number of frames we can have displaying WMTS tiling.
const MAX_WMTS_FRAMES = 7;
// Max num of times we should check WMTS fallbacks, blackness and images, before resorting to viirs cubemaps.
const MAX_DEEP_CHECKS = 14;

const POI_SHOW_ON_GLOBE = false;

const GMAP_SHOW_ON_GLOBE = false;

export {
	EVENT_CATEGORIES,
	EVENTS_YEAR_INDEX,
	EVENTS_CATEGORY_INDEX,
	EVENTS_SHOW_ON_GLOBE,
	EVENTS_SHOW_LATEST,
	EVENTS_LATEST_LIMIT,

	LIGHT_STATUS,
	CITY_NAME_STATUS,
	GROUND_TRACK_STATUS,

	MISSION_CATEGORIES,
	MISSION_TIME_GROUPS,
	MISSION_TIME_GROUP_CATEGORIES,
	MISSION_TIMES,
	MISSIONS_TIME_GROUP_INDEX,
	MISSIONS_CATEGORY_INDEX,

	VITAL_CATEGORIES,
	VITALS_CATEGORY_INDEX,

	MAX_WMTS_FRAMES,
	MAX_DEEP_CHECKS,
	POI_SHOW_ON_GLOBE,
	POI_CATEGORIES,
	POI_YEAR_INDEX,
	POI_CATEGORY_INDEX,
	POI_SHOW_LATEST,
	POI_LATEST_LIMIT,

	GMAP_SHOW_ON_GLOBE,
	GMAP_CATEGORIES,
	GMAP_YEAR_INDEX,
	GMAP_CATEGORY_INDEX,
	GMAP_SHOW_LATEST,
	GMAP_LATEST_LIMIT
};
